import {
  ASSIGN_ALERTS_TO_USER,
  ASSIGN_ALERTS_TO_USER_SUCCESS,
  ASSIGN_ALERTS_TO_USER_FAIL,
  ALERT_ACTION_INFO_MODAL_CLOSE,
  ASSIGN_ALERTS_TO_USER_RESET
} from '../../actions/cm/alertAction';

export const initialState = {
  isLoading: false,
  hasError: false,
  showInfoModal: false,
  errorMessage: ''
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case ASSIGN_ALERTS_TO_USER:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: ''
      };
    case ASSIGN_ALERTS_TO_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showInfoModal: true
      };
    case ASSIGN_ALERTS_TO_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case ALERT_ACTION_INFO_MODAL_CLOSE:
      return {
        ...state,
        showInfoModal: false,
        isLoading: false
      };
    case ASSIGN_ALERTS_TO_USER_RESET:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        errorMessage: ''
      };
    default:
      return state;
  }
}
